import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";

import { PlantillasCoreService } from "@pages/configuracion/services/plantillas-core.service";

/**
 * La lista de usuarios habilitados vive en el back: el guard solo pregunta. Ante cualquier respuesta
 * que no sea 200 vuelve al inicio sin mostrar nada, para no anunciar que la pantalla existe.
 */
export const herramientaPlantillasGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const inicio: UrlTree = inject(Router).createUrlTree(["/inicio"]);

  return inject(PlantillasCoreService)
    .acceso()
    .pipe(
      map((respuesta) => (respuesta?.registro?.habilitado === true ? true : inicio)),
      catchError(() => of(inicio)),
    );
};
